import styled from 'styled-components';
import { Box } from '../../../CommonComponents/OPL/Box/Box';

export const ListWrapper = styled(Box)(({ theme }) => ({
  '&:nth-child(even)': {
    background: theme.colors.neutral['100'],
  },
  '&:hover div': {
    fontWeight: 600,
  },
}));
